import { CloudDataAdaptersCSVFiles } from "@graylog/enterprise-api";
import { Builder, fetchFile } from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import { downloadBLOB } from "util/FileDownloadUtils";
const sourceUrl = "/plugins/org.graylog.plugins.lookup/data_adapters/csv_files";
export const getUploadField = (id) => {
  const promise = CloudDataAdaptersCSVFiles.metadata(id);
  promise.catch((error) => {
    UserNotification.error(`Fetching file metadata failed with status: ${error.message},
      Could not retrieve file metadata with id:${id}`);
  });
  return promise;
};
export const getUploadFieldConfig = () => {
  const promise = CloudDataAdaptersCSVFiles.config();
  promise.catch((error) => {
    UserNotification.error(`Fetching file upload limit failed with status: ${error.message},
      Could not retrieve file upload limit`);
  });
  return promise;
};
export const downloadUploadedFile = (id) => {
  const url = qualifyUrl(`${sourceUrl}/${id}`);
  const promise = Promise.all([fetchFile("GET", url, void 0, "text/csv"), getUploadField(id)]).then(
    ([contents, metadata]) => {
      downloadBLOB(contents, { fileName: metadata.file_name, contentType: metadata.content_type });
    }
  );
  promise.catch((error) => {
    UserNotification.error(`Downloading file failed with status: ${error.message},
      Could not download file with id:${id}`);
  });
  return promise;
};
export const uploadFile = (file) => {
  const url = qualifyUrl(sourceUrl);
  const formData = new FormData();
  formData.append("file", file);
  return new Builder("POST", url).formData(formData).build();
};
